import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import{
    infoSession,
} from '../config/Utils';

import user1 from '../images/users/no-pic.png';

class ProfileMenu extends Component {
	constructor(props) {
        super(props);
        this.state = {
            menu: false,
            username: "Admin"
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }


    render() {
        return (
        	<React.Fragment>
        		<Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block" >
                    <DropdownToggle className="btn header-item waves-effect" id="page-header-user-dropdown" tag="button">
                        <img className="rounded-circle header-profile-user" src={user1} alt="Header Avatar" />
                        <span className="d-none d-xl-inline-block ml-2 mr-1">{infoSession("nama")}</span>
                        <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                    </DropdownToggle>
                    <DropdownMenu right>
                        {/*<DropdownItem tag="a" href="#">
                            <i className="bx bx-user font-size-16 align-middle mr-1"></i>
                            {'Profile'}
                        </DropdownItem>*/}
                        <DropdownItem tag="a" href="#" data-toggle="modal" data-target="#modal-ubah-password">
                            <i className="bx bx-wrench font-size-17 align-middle mr-1"></i>
                            {'Ubah Password'}
                        </DropdownItem>
                        <div className="dropdown-divider"></div>
                        <Link to="/logout" className="dropdown-item" onClick={()=>{
                            window.sessionStorage.clear()
                            window.location = '/'
                        }}>
                            <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
                            <span>{'Logout'}</span>
                        </Link>
                    </DropdownMenu>
                </Dropdown>

                
        	</React.Fragment>
        )
    }

}
export default ProfileMenu;